"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isLegalDisclaimerProperty = exports.legalDisclaimerPropertyDefinition = void 0;
exports.legalDisclaimerPropertyDefinition = {
    name: 'legal-disclaimer',
    type: 'rich-text',
    constraints: [
        {
            name: 'maxLength',
            argument: 500,
        },
    ],
    multiple: false,
    view: {
        label: 'Legal disclaimer',
        style: 'h4',
    },
};
const isLegalDisclaimerProperty = (prop) => {
    return prop.name === exports.legalDisclaimerPropertyDefinition.name;
};
exports.isLegalDisclaimerProperty = isLegalDisclaimerProperty;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoibGVnYWwtZGlzY2xhaW1lci5wcm9wZXJ0eS5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9wcm9wZXJ0aWVzL2xlZ2FsLWRpc2NsYWltZXIucHJvcGVydHkudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7O0FBRWEsUUFBQSxpQ0FBaUMsR0FBRztJQUMvQyxJQUFJLEVBQUUsa0JBQWtCO0lBQ3hCLElBQUksRUFBRSxXQUFXO0lBQ2pCLFdBQVcsRUFBRTtRQUNYO1lBQ0UsSUFBSSxFQUFFLFdBQVc7WUFDakIsUUFBUSxFQUFFLEdBQUc7U0FDZDtLQUNGO0lBQ0QsUUFBUSxFQUFFLEtBQUs7SUFDZixJQUFJLEVBQUU7UUFDSixLQUFLLEVBQUUsa0JBQWtCO1FBQ3pCLEtBQUssRUFBRSxJQUFJO0tBQ1o7Q0FDOEIsQ0FBQTtBQUkxQixNQUFNLHlCQUF5QixHQUFHLENBQUMsSUFBa0IsRUFBbUMsRUFBRTtJQUMvRixPQUFPLElBQUksQ0FBQyxJQUFJLEtBQUsseUNBQWlDLENBQUMsSUFBSSxDQUFBO0FBQzdELENBQUMsQ0FBQTtBQUZZLFFBQUEseUJBQXlCLDZCQUVyQyJ9